import { usePathname, useSearchParams } from 'next/navigation'

export const useCurrentPath = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const query = searchParams.toString()
	const currentPath = query ? `${pathname}?${query}` : pathname

	return {
		link: currentPath,
		withSalt: `prev=${encodeURIComponent(currentPath)}`
	}
}
